import { Badge } from "@fluentui/react-components";
import { LeaveStatus } from "../../models/leaveModels";

type BadgeColor =
  | "brand"
  | "danger"
  | "important"
  | "informative"
  | "severe"
  | "subtle"
  | "success"
  | "warning";

const STATUS_COLOR: Record<LeaveStatus, BadgeColor> = {
  Draft: "informative",
  Pending: "warning",
  Approved: "success",
  "Auto-Approved": "success",
  Rejected: "danger",
  Cancelled: "subtle",
};

export function StatusBadge({ status }: { status: LeaveStatus }) {
  return (
    <Badge appearance="filled" color={STATUS_COLOR[status]}>
      {status}
    </Badge>
  );
}
